import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import colors from "../../assets/theme/base/colors";
import MKBox from "../../components/MKBox";
import CloseIcon from "@mui/icons-material/Close";
import constants from "../../common/constants";
import { useState } from "react";
import { Typography } from "@mui/material";

const MaintenanceBanner = () => {
  const maintenanceMessage = constants.MaintenanceMessage;
  const [isShow, setIsShow] = useState(constants.ShowMaintenance);
  const onClickClose = () => {
    setIsShow(false);
    var xDateTimeNow = new Date();
    console.log(xDateTimeNow);
  };

  return (
    isShow && (
      <>
        <MKBox
          minHeight="6vh"
          maxHeight="30vh"
          width="100%"
          pb={0}
          sx={{
            backgroundColor: colors.error.main,
            backgroundSize: "cover",
            backgroundPosition: "left",
            display: "grid",
            placeitems: "center",
            alignItems: "end",
          }}
        >
          <Grid
            container
            pt={1}
            pl={2}
            pb={1}
            sx={{
              opacity: "100%",
              display: "row",
              placeitems: "right",
            }}
          >
            <Grid item xs={11}>
              <Typography
                variant="body2"
                color="white"
                sx={({ breakpoints }) => ({
                  minHeight: "6vh",
                  fontFamily: "Barlow",
                  color: colors.white.focus,
                  fontWeight: "400",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  [breakpoints.down("md")]: {
                    fontSize: "small",
                  },
                })}
              >
                {maintenanceMessage}
              </Typography>
            </Grid>
            {!constants.MaintenanceIsShowAlways && (
              <Grid item xs={1} md={1} pr={2}>
                <Box
                  direction="column"
                  alignItems="center"
                  justifyContent={"flex-end"}
                  height={"100%"}
                  sx={({ breakpoints }) => ({
                    width: "flex",
                    flexGrow: 3,
                    display: { xs: "flex", md: "flex" },
                    [breakpoints.down("md")]: {},
                  })}
                >
                  <IconButton onClick={() => onClickClose()}>
                    <CloseIcon color="white" />
                  </IconButton>
                </Box>
              </Grid>
            )}
          </Grid>
        </MKBox>
      </>
    )
  );
};

export default MaintenanceBanner;
